<script>
	export let text;
	export let icon = "";
	export let color = "#000";
</script>

<div class="headline" style:color>
	<img src={`${PATH}${icon}`} class="icon" />
	{text}
</div>

<style lang="scss">
	.headline {
		font-weight: 600;
		font-size: 16px;
		line-height: 19px;
		margin-bottom: 11px;
		position: relative;
		left: -5px;
	}

	@media (min-width: 840px) {
		.headline {
			font-size: 20px;
		}
	}

	.icon {
		// margin: 0 4px 4px 0;
		// vertical-align: middle;
		vertical-align: text-top;
		// max-height: 16px;
		// width: 16px;
		width: 22px;
		// width: unset;
		display: unset;
	}
</style>
